import type { Novidade } from './tipos';

/** Ficha 2026-11-03 (e-mail não cria contato), opção A do Gustavo em 04/11: cadastrar o contato pela conversa. */
export const novidadeContatoPelaConversa: Novidade = {
  id: '2026-11-04-contato-pela-conversa',
  publicada_em: '2026-11-04',
  tipo: 'melhoria',
  modulo: 'conversas',
  permissao: 'cadastros.criar',
  textos: {
    pt: {
      titulo: 'Contato só entra quando você cadastra',
      resumo: 'E-mail de remetente desconhecido não cria mais contato sozinho. Quando fizer sentido, cadastre pela própria conversa.',
      passos: ['Abra a conversa de e-mail em Comercial > Conversas > E-mail.', 'Clique em Cadastrar contato, confira o nome e confirme. A conversa fica ligada ao contato.'],
    },
    en: {
      titulo: 'Contacts only enter when you register them',
      resumo: 'Email from an unknown sender no longer creates a contact by itself. When it makes sense, register it from the conversation.',
      passos: ['Open the email conversation in Sales > Conversations > Email.', 'Click Register contact, check the name and confirm. The conversation is linked to the contact.'],
    },
    es: {
      titulo: 'El contacto solo entra cuando lo registras',
      resumo: 'El correo de un remitente desconocido ya no crea un contacto solo. Cuando tenga sentido, regístralo desde la conversación.',
      passos: ['Abre la conversación de correo en Comercial > Conversaciones > Correo.', 'Haz clic en Registrar contacto, revisa el nombre y confirma. La conversación queda vinculada al contacto.'],
    },
  },
  treinamento: { curso: 'novidades' },
  rota: '/comercial/conversas/email',
  imagens: ['/novidades/2026-11-04-contato-pela-conversa/formulario.webp', null],
};
